import styled from 'styled-components'

export const EventItem = styled.div`
margin-bottom: 20px;
position: relative;
border: 1px solid #e5e5e5;
background-color: white;
img{
    width: 100%;
    height: 180px;
}
hr{
    margin: 7px 0px;
}
`;

export const EventText = styled.div`
padding: 18px 20px 1px;
a{
    font-weight: 700;
    color: black;
    :hover{
        text-decoration:underline;
        color: var(--primaryColor);
    }
}
> p{
    color: #676767;
    font-size: 13px;
    margin-bottom: 10px;
}
`;

export const EventInfo = styled.div`
display: flex;
justify-content: space-between;
>span {
    height: 36px;
    background-color: #e2e2e2;
    width: 2px;
    display: block;
}
`;

export const EventInfoItem = styled.div`
padding: 1px 20px 10px;
i , span{
    font-size: 14px;
    color: #55585a;
}
i{
    margin: 0px 4px;
    color: var(--primaryColor);
}
`;

export const EventDate = styled.div`
position: absolute;
top: 15px;
left: 20px;
background-color:var(--primaryColor);
padding: 4px 14px;
border-radius: 3px;
color: white;
span:nth-child(1){
    margin-right:5px ;
}
`;
